import type { DesignTokens } from "../types/theme";

const WEB_SYSTEM_FONT =
  "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";

/**
 * Base tokens for Light mode.
 */
export const LIGHT_BASE_TOKENS: DesignTokens = {
  background: "#faf6f0",
  foreground: "#3a2e26",
  surface: "#fdfbf7",
  surfaceForeground: "#3a2e26",
  surfaceSecondary: "#f3ece2",
  surfaceSecondaryForeground: "#3a2e26",
  surfaceTertiary: "#ebe1d3",
  surfaceTertiaryForeground: "#3a2e26",
  overlay: "#fdfbf7",
  overlayForeground: "#3a2e26",
  muted: "#7a6a5b",
  default: "#f2ebe0",
  defaultForeground: "#3a2e26",
  accent: "#d2603a",
  accentForeground: "#fdfbf7",
  danger: "#d64545",
  dangerForeground: "#ffffff",
  warning: "#e0992f",
  warningForeground: "#3a2e26",
  success: "#5a9e52",
  successForeground: "#fdfbf7",
  separator: "#c9b8a4",
  glassBackground: "rgba(253, 251, 247, 0.72)",
  glassBorder: "rgba(58, 46, 38, 0.1)",
  glassHighlight: "rgba(255, 255, 255, 0.5)",
  glow0: "rgba(210, 96, 58, 0.14)",
  glow1: "rgba(90, 158, 82, 0.1)",
  glow2: "rgba(224, 153, 47, 0.09)",
  mutedForeground: "#3a2e26",
  patternType: "none",
  patternOpacity: 10,
  surfaceShadow: "rgba(74, 52, 38, 0.12)",
  overlayShadow: "rgba(74, 52, 38, 0.18)",
  fieldShadow: "rgba(74, 52, 38, 0.06)",
  fieldBorder: "rgba(58, 46, 38, 0.12)",
  fieldPlaceholder: "rgba(58, 46, 38, 0.45)",
  fieldBackground: "rgba(58, 46, 38, 0.04)",
  segment: "#fdfbf7",
  segmentForeground: "#3a2e26",
  link: "#d2603a",
  focus: "#d2603a",
  fieldForeground: "#3a2e26",
  radius: "0.75rem",
  fontNormal: WEB_SYSTEM_FONT,
  fontMedium: WEB_SYSTEM_FONT,
  fontSemiBold: WEB_SYSTEM_FONT,
  fontBold: WEB_SYSTEM_FONT,
  border: "#c9b8a4",
  primary: "#d2603a",
  primaryForeground: "#fdfbf7",
  secondary: "#f2ebe0",
  secondaryForeground: "#3a2e26",
  backdrop: "rgba(40, 28, 20, 0.5)",
};

/**
 * Base tokens for Dark mode.
 */
export const DARK_BASE_TOKENS: DesignTokens = {
  background: "#221c17",
  foreground: "#f7f1e8",
  surface: "#2e2620",
  surfaceForeground: "#f7f1e8",
  surfaceSecondary: "#372e26",
  surfaceSecondaryForeground: "#f7f1e8",
  surfaceTertiary: "#42382e",
  surfaceTertiaryForeground: "#f7f1e8",
  overlay: "#332a23",
  overlayForeground: "#f7f1e8",
  muted: "#b3a394",
  default: "#3f352c",
  defaultForeground: "#f7f1e8",
  accent: "#e87a4e",
  accentForeground: "#221c17",
  danger: "#e2574f",
  dangerForeground: "#ffffff",
  warning: "#edab45",
  warningForeground: "#3a2e26",
  success: "#6cb262",
  successForeground: "#221c17",
  separator: "#5a4d40",
  glassBackground: "rgba(46, 38, 32, 0.55)",
  glassBorder: "rgba(247, 241, 232, 0.12)",
  glassHighlight: "rgba(247, 241, 232, 0.22)",
  glow0: "rgba(232, 122, 78, 0.45)",
  glow1: "rgba(108, 178, 98, 0.38)",
  glow2: "rgba(237, 171, 69, 0.3)",
  mutedForeground: "#f7f1e8",
  patternType: "none",
  patternOpacity: 10,
  surfaceShadow: "rgba(0, 0, 0, 0.4)",
  overlayShadow: "rgba(0, 0, 0, 0.55)",
  fieldShadow: "rgba(0, 0, 0, 0.3)",
  fieldBorder: "rgba(247, 241, 232, 0.11)",
  fieldPlaceholder: "rgba(247, 241, 232, 0.42)",
  fieldBackground: "rgba(247, 241, 232, 0.04)",
  segment: "#473c31",
  segmentForeground: "#f7f1e8",
  link: "#e87a4e",
  focus: "#e87a4e",
  fieldForeground: "#f7f1e8",
  radius: "0.75rem",
  fontNormal: WEB_SYSTEM_FONT,
  fontMedium: WEB_SYSTEM_FONT,
  fontSemiBold: WEB_SYSTEM_FONT,
  fontBold: WEB_SYSTEM_FONT,
  border: "#5a4d40",
  primary: "#e87a4e",
  primaryForeground: "#221c17",
  secondary: "#3f352c",
  secondaryForeground: "#f7f1e8",
  backdrop: "rgba(0, 0, 0, 0.7)",
};
